import { UserRole } from '../../enums/user/user-role.enum';

export const ClientConstants = {
  DEFAULT_CLIENT_ID: 'frontend',
  ROLES_ORDERED_ASCENDING: [UserRole.User, UserRole.Admin, UserRole.Owner] as const, // Order is important!,
};
